module.exports = __webpack_public_path__ + "img/jardin2.8bc4e9ba.jpg";